/* eslint-disable @typescript-eslint/no-explicit-any */
// This file manages exports from the base atom, molecule, or organism.
// Use named rather than default exports.
import dynamic from 'next/dynamic';
import { EditableComponent } from '@adobe/aem-react-editable-components';

import { constants } from '../../modules/utils/constants';
const SavedHotelsDetails = dynamic(() => import('./SavedHotelsDetails').then(mod => mod.SavedHotelsDetails));
const SavedHotelsDetailsV2 = dynamic(() => import('./SavedHotelsDetailsV2').then(mod => mod.SavedHotelsDetailsV2));

export const SavedHotelsDetailsConfig = {
  emptyLabel: 'savedHotelsDetails',
  isEmpty: false,
  resourceType: `mi-aem-account/components/content/savedHotelsDetails`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const SavedHotelsDetailsEditable = (props: any) => (
  <EditableComponent config={SavedHotelsDetailsConfig} {...props}>
    {props?.model?.variation === constants.VARIATION_2 ? (
      <SavedHotelsDetailsV2 {...props} />
    ) : (
      <SavedHotelsDetails {...props} />
    )}
  </EditableComponent>
);
